<template>
  <section id="SectionHowItWorks">
    <Wrap class="lg">
      <Row>
        <Column :md="6" />
        <Column class="header" :md="6">
          <h3>
            {{ headline || $t('title') }}
          </h3>
        </Column>
      </Row>
      <Row>
        <Column :md="6">
          <div class="left">
            <Pic :formats="['webp']" loading="lazy" src="../../assets/work-scheme.png" />
          </div>
        </Column>
        <Column :md="6">
          <div class="right">
            <div class="label">
              {{ $t('label') }}
            </div>
            <ol>
              <li v-for="item in $ta('items')" :key="item">
                {{ item }}
              </li>
            </ol>
          </div>
        </Column>
      </Row>
    </Wrap>
  </section>
</template>

<script>
export default {
  props: {
    headline: String,
  },
}
</script>

<style lang="scss">
#SectionHowItWorks {
  background-color: $white;
  padding: 8rem 0;

  .left {
    padding: 0 4rem;

    img {
      height: auto;
      object-fit: cover;
      width: 100%;
    }
  }

  .header {
    h2 {
      color: $main;
      display: inline;
      padding-right: 1rem;
    }

    h3 {
      display: inline;
      padding-bottom: 5rem;

      .Icon {
        color: $main;
        padding-right: 1rem;
      }
    }
  }

  .right {
    padding-left: 2rem;
    padding-top: 5rem;
    @include md {
      padding-left: 0;
    }

    .label {
      font-weight: $bold;
      padding-bottom: 3rem;
    }

    li {
      color: $grey;
      margin-left: 1rem;
      padding: 1rem 0 1rem 2rem;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Kaip veikia saulės elektrinė?",
    "label": "Saulės elektrinės dalys ir įrengimo etapai:",
    "items": [
      "Saulės moduliai, montuojami ant namo stogo arba ant žemės",
      "Modulių išdėstymui skirta konstrukcija, tvirtinama ant namo stogo arba statoma ant žemės",
      "Optimizatoriai, tvirtinami, kai montuojama išmani saulės sistema",
      "Inverteris, keičiantis nuolatinę (DC) elektros srovę į kintamą (AC)",
      "Elektros tinklai, į kuriuos nukeliauja sugeneruotas elektros perteklius"
    ]
  }
}
</i18n>
